<template>
  <v-dialog
    v-model="showModal"
    persistent
    max-width="700px"
    overlay-opacity="1"
  >
    <v-card class="modalCard">
      <v-card-title class="modalTitle pt-2 pb-1 mb-2">
        <h2>Jūsų sesija baigėsi</h2>
      </v-card-title>
      <v-card-text class="pt-2 pb-2">
        <v-card class="mb-2 py-4">
          <v-card-text>
            <v-row no-gutters>
              <v-col cols="12"
                >Baigėsi Jūsų sesijos laikas. Norėdami tęsti darbą prisijunkite
                iš naujo.</v-col
              >
            </v-row>
          </v-card-text>
        </v-card>
      </v-card-text>
      <v-card-actions class="modalActions" elevation="5">
        <v-spacer></v-spacer>
        <el-button primary @click.native.stop="saveData()">
          Prisijungti
        </el-button>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
export default {
  name: 'ModalIdle',
  props: {
    value: Boolean,
  },
  data() {
    return {}
  },
  computed: {
    showModal: {
      get() {
        return this.value
      },
      set(value) {
        this.$emit('input', value)
      },
    },
  },
  methods: {
    saveData() {
      this.$router.push({ name: 'home' })
      this.closeModal()
    },
    cancelData() {
      this.closeModal()
    },
    closeModal() {
      this.showModal = false
    },
  },
}
</script>
<style lang="scss" scoped>
.modalCard {
  background: #f5f5f5 !important;
}
.modalTitle {
  background: #f5f5f5 !important;
  position: sticky;
  top: 0;
  z-index: 2;
  background: none;
  border-bottom: thin solid rgba(0, 0, 0, 0.12);
}
.modalActions {
  position: sticky;
  bottom: 0;
  z-index: 1;
}
</style>
